import history from 'history/browser';

export default history;
